<template>
    <div class="reference-house">
        <div v-if="hasImage" v-bind:style="{'background-image': refHouseImage}" class="reference-house-image"></div>
        <div class="reference-house-description">
            <h3>{{ refHouse.name }}</h3>
            <span v-if="refHouse.matchCriteria" class="title-right">(Bra val)</span>
            <ul>
                <li><strong>{{ this.productLabel }}</strong>: {{ refHouse.product.productName }}</li>

                <li>{{ refHouse.minNumberOfFloors }}&ndash;{{ refHouse.maxNumberOfFloors }} våningar</li>
                <li>{{ refHouse.standardFloorNumberOfApartments }} bostäder per normalplan</li>
                <li>{{ refHouse.standardFloorLivingArea }} kvm (BOA) per normalplan</li>
                <li>
                    <strong>Bostadstyper</strong>:
                    <ul class="reference-house-description-list">
                        <li v-for="apartment in sortBySize(apartments)">
                            {{ apartmentSizeDict.find(size => size.id === apartment.size).label }}, {{ apartment.area }} kvm
                        </li>
                    </ul>
                </li>
                <li>
                    <strong>Fasad:</strong> {{ refHouse.facadeDescription }}
                </li>
                <li>
                    <strong>Tak:</strong> {{ refHouse.roofDescription }}
                </li>
                <li>
                    <strong>Stomme:</strong> {{ refHouse.frameDescription }}
                </li>
                <li><strong>Energiförbrukning:</strong> {{ refHouse.powerConsumption }} per kvm &amp; år</li>
                <li>
                    <strong>Grundpris:</strong>
                    {{ refHouse.defaultBasePrice | prettyNumber}} per BOA + LOA
                    <help-box title="BOA + LOA" message="Bostadshuset exkl grundläggning, markarbeten och moms." :message-ref="'carousel-' + refHouse.id" />
                </li>
                <li>
                    <strong>Leverantör:</strong> {{ refHouse.developer }}
                </li>
                <li>&nbsp;</li>
                <template v-if="refHouse.limitedGeographicalAvailability">
                    <li><strong>OBS!</strong> Begränsad tillgänglighet</li>
                    <li>{{ refHouse.limitedGeographicalAvailabilityNote }}</li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import HelpBox from "./saboHelpBox";

    export default {
        props: {
            refHouse: { type: Object, required: true },
            apartmentSizeDict: { type: Array, required: true }
        },

        data() {
            return {
                showContactInfo: false
            }
        },

        filters: {
            prettyNumber(number) {
                return number.toLocaleString('sv-SE');
            }
        },

        computed: {
            ...mapState({
                productLabel(state) {
                    return state.procurementModel === 1 ? "Leverantör" : "Produkt"
                },
            }),
            mailto() {
                return "mailto:" + this.supplierAddress.email;
            },
            defaultBasePrice() {
                return this.refHouse.defaultBasePrice;
            },
            hasImage() {
                return this.refHouse.images.length > 0;
            },
            refHouseImage() {
                return `url(/referencehouses/${this.refHouse.id}/images/${this.refHouse.images[0].id})`;
            },
            apartments() {
                return this.refHouse.distinctApartments.slice(0);
            }
        },

        methods: {
            sortBySize: (apartmentList) => apartmentList.sort((a, b) => a.size - b.size)
        },

        components: {
            HelpBox,
        },
    }
</script>

<style lang="scss">
    // SCSS is found in reference-house-selector.scss and is shared with other House non-Vue component
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/refHouse.vue